module.exports = __webpack_public_path__ + "img/close.f8e35045.svg";